export default __webpack_public_path__ + "static/font-963020e62d7684ffe6334543f171e74b.png";